import { APP_BRAND_COLOR } from './app';
const TRANSACTION_TABLE_HEADERS = [
  {
    name: 'Customer',
    column: 'customer/email'
  },
  {
    name: 'Description',
    column: 'description'
  },
  {
    name: 'Initiated Amount',
    column: 'initialized_amount',
    currency: 'initialized_currency'
  },
  {
    name: 'Amount',
    column: 'payment_amount',
    currency: 'payment_currency'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

const ADMIN_TRANSACTION_TABLE_HEADERS = [
  {
    name: 'Merchant',
    column: 'merchant/name'
  },
  {
    name: 'Customer',
    column: 'customer/email'
  },
  {
    name: 'Description',
    column: 'description'
  },
  {
    name: 'Initiated Amount',
    column: 'initialized_amount',
    currency: 'initialized_currency'
  },
  {
    name: 'Quoted Amount',
    column: 'payment_amount',
    currency: 'payment_currency'
  },
  {
    name: 'Amount Paid',
    column: 'amount_paid',
    currency: 'payment_currency'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

const TRANSACTION_FILTERS = [
  {
    label: 'Yearly',
    value: 'yearly'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Weekly',
    value: 'weekly'
  },
  {
    label: 'Daily',
    value: 'daily'
  }
];

const TRANSACTION_STATUSES = [
  {
    label: 'All Transactions',
    value: ''
  },
  {
    label: 'Initiated',
    value: 'INITIATED'
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Successful',
    value: 'SUCCESSFUL'
  },
  {
    label: 'Abandoned',
    value: 'ABANDONED'
  }
];
const DATE_OPTIONS = [
  {
    label: 'Last day',
    value: 'day'
  },
  {
    label: 'Last 7 days',
    value: 'week'
  },
  {
    label: 'Last 30 days',
    value: 'month'
  },
  {
    label: 'Last quarter',
    value: 'quarter'
  },
  {
    label: 'Last year',
    value: 'year'
  }
];

const DEFAULT_TRANSACTION_FILTER = 'monthly';

const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        display: false
      }
    },
    x: {
      grid: {
        display: false
      }
    }
  }
};

const CHART_CONFIG = {
  label: 'transactions',
  fill: true,
  borderColor: APP_BRAND_COLOR,
  tension: 0.5,
  pointRadius: 0.3,
  pointHoverRadius: 8,
  pointHoverBorderWidth: 5,
  borderWidth: 2,
  pointHoverBackgroundColor: APP_BRAND_COLOR,
  pointHoverBorderColor: '#FFFFFF'
};

export {
  ADMIN_TRANSACTION_TABLE_HEADERS,
  CHART_CONFIG,
  CHART_OPTIONS,
  DATE_OPTIONS,
  DEFAULT_TRANSACTION_FILTER,
  TRANSACTION_FILTERS,
  TRANSACTION_STATUSES,
  TRANSACTION_TABLE_HEADERS
};
